import {SettlementSettingsTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function settlementSettingFilter(settingType: SettlementSettingsTypeEnum): string {
  switch (settingType) {
    case SettlementSettingsTypeEnum.ServiceFee: return i18n.t(LF.ServiceFee) as string;
    case SettlementSettingsTypeEnum.ResetIsContactedForDebt: return i18n.t(LF.DaysUntilIsContactedForDebtReset) as string;
    case SettlementSettingsTypeEnum.PetrolVatRate: return i18n.t(LF.PetrolVatRate) as string;
    default: return '';
  }
}
